import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* stopBreakoutRoomsSaga() {
  yield call(SignalingSocket.send, {
    event: 'stopBreakoutRooms',
  });
}
